/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Sampling_Rate_LabelInputs */



/**
* | output |
* | --- |
* | "Sampling Rate (seconds)" |
*
* @param {Ocr_Sampling_Rate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_sampling_rate_label = /** @type {((inputs?: Ocr_Sampling_Rate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Sampling_Rate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fréquence d'échantillonnage (secondes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abtastrate (Sekunden)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Frequenza di campionamento (secondi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Частота дискретизации (в секундах)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Frecuencia de muestreo (segundos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("采样率（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サンプリングレート（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नमूनाकरण दर (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Taxa de amostragem (segundos)")
	return /** @type {LocalizedString} */ ("Sampling Rate (seconds)")
});